import './common-fields.scss';

import React from 'react';

import FieldLabel from './FieldLabel';

type Props = {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  placeholder?: string;
  showError?: boolean;
  error?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  type?: string;
  autoComplete?: string;
  /** When true, fully hidden in OpenReplay replay. Ignored if phiSanitize is true. */
  phiHidden?: boolean;
  /** When true, masked in OpenReplay replay. Ignored if phiHidden is true. */
  phiSanitize?: boolean;
  onBlur?: () => void;
  onChange: (val: string) => void;
};

export default function InputField({
  id,
  label,
  required,
  value,
  placeholder,
  onChange,
  onBlur,
  showError,
  error,
  inputRef,
  type = 'text',
  autoComplete,
  phiHidden,
  phiSanitize,
}: Props) {
  const errorId = `${id}-error`;
  const openReplayAttrs = phiHidden
    ? { 'data-openreplay-hidden': true }
    : phiSanitize
      ? { 'data-openreplay-sanitize': true }
      : {};
  return (
    <div className='po-field'>
      <FieldLabel htmlFor={id} required={required}>
        {label}
      </FieldLabel>
      <input
        id={id}
        name={id}
        className='po-input'
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-invalid={!!showError}
        aria-required={!!required}
        aria-describedby={showError && error ? errorId : undefined}
        ref={inputRef}
        type={type}
        autoComplete={autoComplete}
        onBlur={onBlur}
        {...openReplayAttrs}
      />
      {showError && error ? (
        <div id={errorId} className='po-error inline' role='alert'>
          {error}
        </div>
      ) : null}
    </div>
  );
}
